import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchCondiciones, fetchUsos, fetchColores, clearCondiciones, clearUsos, clearColores,fetchClientes,clearClientes } from '../../../actions';
import validateClient from '../../../utils/validateClient';
import Alert from '../../../components/Alert';


class SecondStep extends Component {
  constructor(props) {
    super(props);
    let capacitacionesProforma = [];
    let coloresProforma = {};
    let usosProforma = {};
    let condicionesProforma = {};

    this.props.proformas.forEach(({ nroProforma, codFamilia }) => {
      if (codFamilia === '2' || codFamilia === '3') {
        capacitacionesProforma.push(nroProforma);
      }
      usosProforma[nroProforma] = '';
      condicionesProforma[nroProforma] = [];
      coloresProforma[nroProforma] = [''];
    });

    if (this.props.capacitacionesProforma) {
      capacitacionesProforma = this.props.capacitacionesProforma;
    }

    if (this.props.usosProforma) {
      usosProforma = this.props.usosProforma;
    }

    if (this.props.condicionesProforma) {
      condicionesProforma = this.props.condicionesProforma;
    }

    if (this.props.coloresProforma) {
      coloresProforma = this.props.coloresProforma;
    }

    this.state = {
      cardExpanded: this.props.cardExpanded,
      condicionesProforma,
      capacitacionesProforma,
      usosProforma,
      coloresProforma,
      newclientId: '',
      newclientName: '',
    };
  }

  componentDidMount() {
    this.props.fetchCondiciones(this.props.codAreaVta);
    this.props.fetchUsos(this.props.proformas);
    this.props.fetchColores(this.props.proformas);
  }

  onChangeCondicion = (e, proforma) => {
    const condicion = e.target.name;
    const { condicionesProforma } = this.state;
    if (condicionesProforma[proforma].indexOf(condicion)>=0) {
      condicionesProforma[proforma] = condicionesProforma[proforma]
                                        .filter(cond => cond !== condicion);
    } else {
      condicionesProforma[proforma] = [...condicionesProforma[proforma], condicion];
    }
    this.setState({ condicionesProforma });
  }

  onChangeCapacitacion = (e) => {
    const capacitacion = e.target.id;
    const { capacitacionesProforma } = this.state;
    if (capacitacionesProforma.indexOf(capacitacion)>=0) {
      this.setState({ capacitacionesProforma: capacitacionesProforma
                                            .filter(cond => cond !== capacitacion) });
    } else {
      this.setState({ capacitacionesProforma: [...capacitacionesProforma, capacitacion] });
    }
  }

  onChangeColor = (e, proforma, index) => {
    const color = e.target.value;
    const { coloresProforma } = this.state;
    coloresProforma[proforma][index] = color;
    this.setState({ coloresProforma });
  }

  onChangeUso = (e, proforma) => {
    const { usosProforma } = this.state;
    usosProforma[proforma] = e.target.value;
    this.setState({ usosProforma });
  }

  goBack = () => {
    this.props.clearCondiciones();
    this.props.clearUsos();
    this.props.clearColores();
    this.props.previousStep();
  }

  addColor = (proforma) => {
    const { coloresProforma } = this.state;
    coloresProforma[proforma].push('');
    this.setState({ coloresProforma });
  }

  removeColor = (proforma, index) => {
    const { coloresProforma } = this.state;
    coloresProforma[proforma].splice(index, 1);
    this.setState({ coloresProforma });
  }

  toggleCard = (proforma) => {
    const { cardExpanded } = this.state;
    if (cardExpanded.indexOf(proforma)>=0) {
      this.setState({ cardExpanded: cardExpanded.filter(it => it !== proforma) });
    } else {
      this.setState({ cardExpanded: [...cardExpanded, proforma] });
    }
  }

  search = (option, value) => {
  
    this.setState({
      lastInput: this.state.searchInput,
      lastOption: this.state.searchOption,
      clientTable: true,
      proformTable: false,
    });
    this.props.clearClientes();
    this.props.fetchClientes(option, value);
  }

  showClientProform = (client) => {
    
    validateClient(client.codigo, 0)
      .then(({ estadoTrama, mensaje }) => {
        if (estadoTrama === '1') {
     
          this.setState({
            clientTable: false,
            proformTable: true,
            stillSearch: false,
            newclientName: client.nombre,
            newclientId: client.codigo,
            step: 2,
          });
        } else if (estadoTrama === '0' || estadoTrama === '-1') {
          this.showAndHideAlert(mensaje);
        } else {
          this.showAndHideAlert(`Hubo un error con el servicio ${estadoTrama}`);
        }
      });
      
  }

  showAndHideAlert = (message) => {
    this.setState({ hasError: true, errorMessage: message });
    setTimeout(() => this.setState({ hasError: false }), 5000);
  }

  render() {
    const {
     hasError
    } = this.state;
    const { condiciones, usos, colores ,
     
    } = this.props;

    if (!condiciones || !condiciones.checkCondicion || !usos || !colores) return null;

    return (
      <div>

      <div className="form-group">
          <div className="card card-lg card-plain mb-2">
                  <div className="cd-cont2">
                    <div className="row">
                    <div className="col-md-10">

                        <h3 class="open">Cliente actual :</h3>
                        <h4>{this.props.fichasVenta.nomPerso}</h4>
                        
                        <h3 class="open">Actializar  cliente :</h3>
                        <h4>{this.props.clientName}</h4>
                        
                        </div>

                      </div>
                  </div>
            </div>                                                  
        </div>                                                  


      
        <div className='modal-actions'>
          <button type='button' className='btn btn-return' onClick={this.goBack}>Anterior</button>
          <button
            type='submit'
            className='btn btn-primary pull-right'
            onClick={this.props.guardarCliente}
          >
            Guardar
          </button>
        </div>
        {
          hasError &&
            <Alert type='alert-warning over-modal' icon='ion-alert-circled'>
              <p>{this.state.errorMessage}</p>
            </Alert>
        }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    condiciones: state.condiciones,
    usos: state.usos,
    colores: state.colores,
    clientes: state.clientes,

  };
}

export default connect(
  mapStateToProps, {
    fetchCondiciones, fetchUsos, fetchColores, clearCondiciones, clearUsos, clearColores,fetchClientes,clearClientes

  })(SecondStep);



// WEBPACK FOOTER //
// ./src/pages/modals/CambiarCliente/SecondStep.js